import { Button } from '@material-ui/core';
import styled from 'styled-components';

export const ButtonSuccess = styled(Button)`
background-color: #50A21A;
box-shadow: 0 4px 6px rgba(50, 220, 93, 0.30), 0 1px 3px rgba(0, 0, 0, 0.08);
padding: 7px 14px;
&:hover {
  background-color: #276C09;
}
& .MuiButton-label {
  color: #fff;
}
`;